<template>
  <div class="basicPortContent">
    <Breadcrumb :matched="matched" />
    <el-tabs v-model="activeName" @tab-click="changeClick">
      <el-tab-pane label="美国码头Houses记录" name="americaCustomsHousesRecord">
        <america-customs-houses-record ref="isHousesRecord" />
      </el-tab-pane>
      <el-tab-pane label="美国码头记录" name="americaCustomsRecord">
        <america-customs-record ref="isRecord" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue'
import americaCustomsRecord from './americaCustomsRecord.vue'
import americaCustomsHousesRecord from './americaCustomsHousesRecord.vue'
export default {
  inject: ['reload'],
  components: {
    Breadcrumb,
    americaCustomsRecord,
    americaCustomsHousesRecord,
  },
  data() {
    return {
      matched: '',
      activeName: 'americaCustomsHousesRecord',
    }
  },
  computed: {
    nowCrawl() {
      return this.$store.state.common.nowCrawl
    },
  },
  watch: {
    nowCrawl: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal === true) {
          this.activeName = 'americaCustomsRecord'
          this.$refs.isRecord.isGangPage = true
          this.$refs.isHousesRecord.isRouterPage = false
          this.$refs.isGangShow.searchList()
        }
      },
    },
  },
  mounted() {
    this.reload()
    this.matched = this.$route.matched
    this.$bus.on('chaneCrawlTab', content => {
      this.activeName = 'americaCustomsHousesRecord'
    })
  },
  destroyed() {
    this.$bus.off('chaneCrawlTab')
  },
  methods: {
    changeClick(tab, event) {
      if (tab.label == '美国码头记录') {
        this.$refs.isRecord.isGangPage = true
        this.$refs.isHousesRecord.isRouterPage = false
        this.$refs.isRecord.page.pageSize = 10
        this.$refs.isRecord.page.pageNo = 1
        this.$refs.isRecord.tableData = []
//        this.$refs.isRecord.searchList('reload')
      } else if (tab.label == '美国码头Houses记录') {
        this.$refs.isHousesRecord.isRouterPage = true
        this.$refs.isRecord.isGangPage = false
        this.$refs.isHousesRecord.page.pageSize = 10
        this.$refs.isHousesRecord.page.pageNo = 1
        this.$refs.isHousesRecord.tableData = []
//        this.$refs.isHousesRecord.searchList('reload')
      }
      this.$store.commit('handCrawl', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.basicPortContent {
  padding: 20px 20px 0px 20px;
  .el-tabs {
    background-color: #fff;
    // padding: 10px 20px 20px 20px;
    padding: 10px 0px 20px 0px;
  }
  ::v-deep.el-tabs__item.is-active {
    color: #333;
    font-weight: bold;
  }
  ::v-deep.el-tabs__item:hover {
    color: #333;
  }
  ::v-deep.el-tabs__item {
    font-size: 13px;
  }
  ::v-deep.el-tabs__nav-scroll {
    padding-left: 20px;
  }
}
</style>
